import tw, { css } from 'twin.macro'

const hoverStyles = css`
  &:hover {
    cursor: pointer;

    img {
      ${tw`-rotate-4`}
    }
  }

  img {
    ${tw`rounded-4xl transition duration-300`}
  }
`

export default hoverStyles
